
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/explore/toys/physical",
      function () {
        return require("private-next-pages/explore/toys/physical.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/explore/toys/physical"])
      });
    }
  